const LANGS = [
  { iso: 'en-US', enum: 'EN' },
  { iso: 'ru-RU', enum: 'RU' },
];

const toLangEnum = (value) => LANGS.find((item) => item.iso === value)?.enum || value;

export const langsTransformData = (items = []) =>
  items.map((item) => ({
    ...item,
    availableLangs: (item.availableLangs || []).map(toLangEnum),
    lang: toLangEnum(item.lang),
  }));

export const getEmployee = (data) =>
  data?.partnerClientAccountEmployee?.[0] || data?.partnerClientAccountEmployee || null;
